import { motion } from "framer-motion";
import { GraduationCap, Award, Compass } from "lucide-react";

const LAB =
  "https://images.unsplash.com/photo-1602052577122-f73b9710adba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxwZXN0JTIwY29udHJvbCUyMGNvbnN1bHRhbnQlMjBtaWNyb3Njb3BlJTIwc2NpZW50aWZpYyUyMGxhYnxlbnwwfHx8fDE3OTE3MDk3Njd8MA&ixlib=rb-4.1.0&q=85";

const cards = [
  {
    icon: GraduationCap,
    title: "Laurea in Scienze Agroalimentari (classe L-26)",
    desc: "Conoscenza approfondita della biologia dei parassiti e delle normative igienico-sanitarie.",
  },
  {
    icon: Award,
    title: "Abilitazione Perito Agrario",
    desc: "Competenza tecnica sull'uso sicuro e mirato di principi attivi, prodotti ecologici e protocolli professionali.",
  },
  {
    icon: Compass,
    title: "Metodo Fai-Da-Te Guidato",
    desc: "Ti indico esattamente quali prodotti comprare, dove, ed esattamente come applicarli passo dopo passo.",
  },
];

export const Credentials = () => (
  <section id="chi-sono" className="max-w-6xl mx-auto px-6 py-24">
    <div className="grid grid-cols-12 gap-6 lg:gap-10 items-start">
      <div className="col-span-12 lg:col-span-5">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-terracotta font-bold mb-4">
            Chi ti risponde al telefono
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug text-moss">
            Non un call center.{" "}
            <span className="italic text-mosslight">Un dottore che ha passato anni sul campo.</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-sub">
            Ogni chiamata è con me, Giuseppe Vincenti. Niente intermediari, niente venditori
            di trappole, analisi scientifica del tuo caso e un piano d'azione che puoi
            eseguire in autonomia lo stesso giorno.
          </p>
          <div className="mt-8 overflow-hidden rounded-3xl border border-line shadow-[0_20px_40px_rgba(15,23,20,0.12)]">
            <img src={LAB} alt="Analisi al microscopio in laboratorio" className="h-56 w-full object-cover" />
          </div>
        </motion.div>
      </div>
      <div className="col-span-12 lg:col-span-7 grid gap-5 lg:pt-16">
        {cards.map(({ icon: Icon, title, desc }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, x: 32 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            className="flex gap-5 rounded-3xl bg-white border border-line p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(27,59,43,0.10)]"
          >
            <div className="shrink-0 flex h-12 w-12 items-center justify-center rounded-2xl bg-sage">
              <Icon size={22} className="text-moss" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-ink">{title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-sub">{desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
